import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  TextField,
  MenuItem,
  Divider,
  Typography
} from "@mui/material";
import axios from "axios";
import { baseURL } from "../../../api";
import { Global_Data } from "../../../globalData/GlobalData";
import { toast } from "react-toastify";
import CustomAlert from "../../../component/AlertComponent/Alert";

export default function NewReportDialog({
  open,
  onClose,
  onCreate
}) {
  const { token } = Global_Data?.() || {};

  const [reportName, setReportName] = useState("");
  const [description, setDescription] = useState("");
  const [formType, setFormType] = useState("FORM");
  const [transactionType, setTransactionType] = useState("");
  const [companyId, setCompanyId] = useState("");

  const [transactionTypes, setTransactionTypes] = useState([]);
  const [companies, setCompanies] = useState([]);

  const authHeaders = token
    ? { Authorization: `Bearer ${token}` }
    : {};

  const loadTransactionTypes = async () => {
    try {
      const res = await axios.get(
        `${baseURL}/report/transactiondocument/get`,
        { headers: authHeaders }
      );

      const records = Array.isArray(res?.data?.data)
        ? res.data.data
        : res?.data?.data?.records || [];

      setTransactionTypes(records);
    } catch (error) {
      console.error("Failed to load transaction types", error);
      CustomAlert("error", "Failed to load transaction types.");
    }
  };

  const loadCompanies = async () => {
    try {
      const res = await axios.get(
        `${baseURL}/report/company/get`,
        { headers: authHeaders }
      );

      const records = Array.isArray(res?.data?.data)
        ? res.data.data
        : res?.data?.data?.records || [];

      setCompanies(records);
    } catch (error) {
      console.error("Failed to load companies", error);
      CustomAlert("error", "Failed to load companies.");
    }
  };

  useEffect(() => {
    if (open && token) {
      loadTransactionTypes();
      loadCompanies();
    }
  }, [open, token]);

  const resetForm = () => {
    setReportName("");
    setDescription("");
    setFormType("FORM");
    setTransactionType("");
    setCompanyId("");
  };

  const handleClose = () => {
    resetForm();
    onClose && onClose();
  };

  const handleCreate = () => {
    if (!reportName.trim()) {
      CustomAlert("warning", "Report Name is required.");
      return;
    }

    if (formType === "FORM" && !transactionType) {
      CustomAlert("warning", "Transaction Type is required.");
      return;
    }

    if (formType === "FORM" && !companyId) {
      CustomAlert("warning", "Company is required.");
      return;
    }

    const selectedTransaction = transactionTypes.find(
        item => item.sDocType === transactionType
        );

    const selectedCompany = companies.find(
      item => item.sControlNumber === companyId
    );

    onCreate &&
      onCreate({
        reportName,
        description,
        formType,
        transactionType,
        transactionName: selectedTransaction?.sDocumentName || "",
        companyId,
        companyName: selectedCompany?.sOrgName || ""
      });

    resetForm();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>New Report Design</DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Report Name"
            size="small"
            value={reportName}
            onChange={e => setReportName(e.target.value)}
            required
            fullWidth
          />

          <TextField
            label="Description"
            size="small"
            value={description}
            onChange={e => setDescription(e.target.value)}
            fullWidth
            multiline
            minRows={3}
          />

          <TextField
            select
            label="Form Type"
            size="small"
            value={formType}
            onChange={e => setFormType(e.target.value)}
            fullWidth
          >
            <MenuItem value="FORM">Form</MenuItem>
          </TextField>

          {formType === "FORM" && (
            <>
              <Divider sx={{ my: 1 }} />

              <Typography variant="subtitle2" fontWeight="bold">
                Form Report Settings
              </Typography>

              <TextField
                select
                label="Transaction Type"
                size="small"
                value={transactionType}
                onChange={e => setTransactionType(e.target.value)}
                fullWidth
                required
              >
                <MenuItem value="">Select Transaction Type</MenuItem>

                {transactionTypes.map(item => (
                  <MenuItem key={item.sDocType} value={item.sDocType}>
                    {item.sDocumentName || item.sDocType}
                    </MenuItem>
                ))}
              </TextField>

              <TextField
                select
                label="Company"
                size="small"
                value={companyId}
                onChange={e => setCompanyId(e.target.value)}
                fullWidth
                required
              >
                <MenuItem value="">Select Company</MenuItem>

                {companies.map(item => (
                  <MenuItem
                    key={item.sControlNumber}
                    value={item.sControlNumber}
                  >
                    {item.sOrgName || item.sControlNumber}
                  </MenuItem>
                ))}
              </TextField>
            </>
          )}
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>
          Cancel
        </Button>

        <Button variant="contained" onClick={handleCreate}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}
